import { useMsal } from '@azure/msal-react'
import { useCallback, useRef } from 'react'
import { apiRequest } from '../authConfig'

export function useApiToken() {
  const { instance, accounts } = useMsal()
  const accountRef = useRef(accounts[0])
  accountRef.current = accounts[0]

  return useCallback(async (): Promise<string> => {
    const account = accountRef.current
    if (!account) throw new Error('No active account')
    try {
      const response = await instance.acquireTokenSilent({ ...apiRequest, account })
      return response.accessToken
    } catch {
      const response = await instance.acquireTokenPopup(apiRequest)
      return response.accessToken
    }
  }, [instance])
}
